import { render, staticRenderFns } from "./nodealinfo.vue?vue&type=template&id=b8076a22&scoped=true"
import script from "./nodealinfo.vue?vue&type=script&lang=js"
export * from "./nodealinfo.vue?vue&type=script&lang=js"
import style0 from "./nodealinfo.vue?vue&type=style&index=0&id=b8076a22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8076a22",
  null
  
)

export default component.exports